export let dictList = {
  isTrue: [
    {
      value: true,
      label: '是',
    },
    {
      value: false,
      label: '否',
    },
  ],
  // 收支类型
  inorExType: [
    {
      value: 1,
      label: '收入',
    },
    {
      value: 2,
      label: '支出',
    },
  ],
  // 审核类型
  auditStauts: [
    {
      value: 0,
      label: '未审核',
    },
    {
      value: 1,
      label: '审核成功',
    },
    {
      value: 2,
      label: '驳回',
    },
  ],
  // 线索状态
  onlineStatus: [
    {
      value: 0,
      label: '未审核',
    },
    {
      value: 1,
      label: '已上线',
    },
    {
      value: 2,
      label: '已下线',
    },
    {
      value: 3,
      label: '已下架',
    },
  ],
  // 积分提现状态
  pointAudiStatus: [
    {
      value: 1,
      label: '审核通过',
    },
    {
      value: 2,
      label: '审核驳回',
    },
  ],
}
